
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91participant_93Tz0_45XTmMLuFObnBU0r8TUxJkfDLWBniLjbIy5Y6ss1kMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/[event]/participant/[participant].vue?macro=true";
import { default as _91event_93IGwxrHUAspO23DIbI_tnlLNo35fSdro7i2VIimC73xUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/[event].vue?macro=true";
import { default as _91signature_93GklGZeyIq_45sPrZuGhnJcsEtM5X60gNG8bPWGeV2k3LkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/signatures/[signature].vue?macro=true";
import { default as formqG0RsFvSSWXQEUIc_454KwIMeW9KyXtuIE1HyKFQZl8kkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form.vue?macro=true";
import { default as index8mLfrv2OfbEUZGtoxselE61zgyLpknFuT0GHgWDZ_45u4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/index.vue?macro=true";
import { default as mailBaseDataNPyuT8ZRsEsLvjb0tEc3lTgT2cVS4gqsxsn_45r0Dys1sMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id]/mailBaseData.vue?macro=true";
import { default as mailActivitiesQa9wv0wFKhuERPK4Tn_45h1H5LmmSpa_452Q02y3a6tXtkMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id]/mailActivities.vue?macro=true";
import { default as _91id_93BhXzJL0ZpyYCowKB1ZIc2pZpp9ITlKs4gLsZumeaZPAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id].vue?macro=true";
import { default as index0FEjRD7BUY4tDcM1_n5zrFY5cuVBwgGFeqvENZy809UMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/index.vue?macro=true";
import { default as mailsMED_45SeZrpqJPIQK6zxNilenT8533u_45mq3_djTyjO2PIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails.vue?macro=true";
import { default as eventMailsmGnxr5tlLiSdtBRJbcCZ7p1QNK3vCvMGu7yDnRcVYcIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventMails.vue?macro=true";
import { default as eventLeaders24rmxMxsxwZxz5JmhiEOmF3ADK4FLsXECtp51uXwMacMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventLeaders.vue?macro=true";
import { default as eventBaseDataFtHubGyS_DYicDe32syuGAmSpTNQQ00ZfYE6xU_VqHkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventBaseData.vue?macro=true";
import { default as eventQuestionsgsZ086GZWvpLo9bRpC142j7tFjDSTPWWNErJG_45qvi3gMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventQuestions.vue?macro=true";
import { default as eventActivitiesbGpEG_45QTqWPg_Qr4_92yu2lrSgu7b3QUkZAZ0xfX_ccMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventActivities.vue?macro=true";
import { default as eventParticipantskaSyFNJD8XigIggykfwT5FBQtZ8YTuJHCiFOsIEcJ8oMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventParticipants.vue?macro=true";
import { default as eventCrisisManagersSE0vQgilfPdOJhJBkwkd6u_45ns6KVrxIehehNui2TDwcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventCrisisManagers.vue?macro=true";
import { default as eventParticipantGroupszbxvEVfTxw7zz27Xa4davVwPvIiCRuFpv31N51nBNCUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventParticipantGroups.vue?macro=true";
import { default as eventTemporaryAccessesSyoDaZ21wYkFZyVS85LLZbkC6V96R57yv6y95utn4GcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventTemporaryAccesses.vue?macro=true";
import { default as _91id_93g9dnXxkAggTTYt5AYIKRohD5zR2HbECUG3fc8Su_45_nQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id].vue?macro=true";
import { default as indexXg7mraTWj9m1_45Y9ZaeM2y_YNEdhLnVuqizQjzLwzsskMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/index.vue?macro=true";
import { default as participantMailsnNsykB2foWanwb9gyeCtBDGUqcmcxMd6il_3ZTK28EgMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantMails.vue?macro=true";
import { default as participantAnswers14n28sM8siQtwNXchXppQ6YroHU0_45ORl78iPpPz9XV0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantAnswers.vue?macro=true";
import { default as participantBaseData0IX3CC0JlXU7N1XHw2A5LiviPeWvGyCenXtwHbzRUZMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantBaseData.vue?macro=true";
import { default as participantGuardiansrigEBcwoQ4Vo9SW5GetqBIfS6qMDYba9a3DFVui2dXIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantGuardians.vue?macro=true";
import { default as participantActivities55dTzgVMjynV36PJrpVeVEJnMf4EuoSGJxwnvQZaZHUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantActivities.vue?macro=true";
import { default as participantSubmissionsImFarlVDPJ3zy76Qj3fKYFbbnnmsbnaJlmYExTxvgUUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantSubmissions.vue?macro=true";
import { default as participantEmergencyContactsnX7Wok1pn_45hDSeOmjM6KtIEOJh_C0Eh9bESUIlniy2AMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue?macro=true";
import { default as participantTemporaryAccessesxRc6Cx_ufY8kgpLjKRoKQdSf0ZVURlD3U7FpjvEjH68Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue?macro=true";
import { default as _91id_93dxAdcRTLYH6AGXijLM_pm6roRGqwlmmqST0n5HSeIGUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id].vue?macro=true";
import { default as groupBaseDatakKxpSIzmUZLdRFCWwybxRHfkgfVBCLoibrDnvTTdtdYMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue?macro=true";
import { default as groupActivitiesxsVYcbU8ISXTomqV0S_L8BsJEA5Ed57mhguN1mZXIC8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue?macro=true";
import { default as groupParticipantsrC_1bs_oX8AYqIJy09jB86yL9_45m40vn9FK5dGWmlBZEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue?macro=true";
import { default as groupTemporaryAccessesP__45E2RpQcq9ozj5gKzXsgspc7HR847YWD1RebFEBXoAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue?macro=true";
import { default as _91id_93mPacRK0fkwgFCmv6HVI1hJVICZv4FvjsRWhVZVAG8W8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id].vue?macro=true";
import { default as eventskyP66TkMocj_2d1b72io1tgcLh75x_9TMpakHhu6xdkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events.vue?macro=true";
import { default as rolese9qVgEPhepilx9ACHHNzzOwi7j185v4JnTzJWbZdQnIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/roles.vue?macro=true";
import { default as userBaseDataeuXG8zlPBC30UE2TBopR2qDfUatS4SwgAxApHmfD5dwMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id]/userBaseData.vue?macro=true";
import { default as userActivities0CVwxdPMwuDfSN_Byf5D6e1xEN_aYGaaQapV_QfuDlUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93KUuun7gxHf3_45WKxPm_Z2sshCWAHw18Vit3mJQNd_z_45sMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id].vue?macro=true";
import { default as indexquPaGhj37fax3TEDG0_oIplSr0bCDgEsfxM_W1c_l4YMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/index.vue?macro=true";
import { default as usersUBAr39kuqJfJIGx8Vg63QaYFcCk__45ijuJdUV0G_FT0YMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users.vue?macro=true";
import { default as baseDatatz6VQEQwLuXjSy9mT5kMdhtUYZ_45ItXzKU6LZv_45e6I_8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/baseData.vue?macro=true";
import { default as billingsFFr0cD8JBXwmdFDkrjzMH6WiYRMtpk6bzswkwGeDLksMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/billings.vue?macro=true";
import { default as billingRunsbaL5crpPxGtKcdejUfJ_lYbn97F9yfIgwBhpDK_45A5foMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/billingRuns.vue?macro=true";
import { default as organisationUsersxZZIfsV0BCOKuDsz56Hum2xnAjaKPu40Z8_Hgj3SuoMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationUsers.vue?macro=true";
import { default as organisationPackagexaNjgE2TVNcS1U187_5WQcqIsmU3ah3FUcAD3aoPyQMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationPackage.vue?macro=true";
import { default as organisationBaseDataydTtmgo8ZPNavOYLWnI_45USj8l4jeIliA7sQOEofdiX0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationActivitiesW6Rp0kJT_45pOwvzHfvJCeTp_45luXUcMTaU_ImuUsWF03EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationSystemDataNYbSES1by_45QJfo1z8id8A_45GyY7hz3aoXmPnnkDfdVlMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationSystemData.vue?macro=true";
import { default as organisationMailSettingskXMpvZdzU1is2NMC4k45K2AOlCbTPlX8d2amBE_452Z9QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationMailSettings.vue?macro=true";
import { default as _91id_93P6eMFxI5D73BqCKZSzaYDNKKClgsdm73vzSP2aETxbIMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id].vue?macro=true";
import { default as indexuyWTt7ctz_NJixtYRy3ZyD9bAkqHOrK1zSU4ybFE17EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/index.vue?macro=true";
import { default as organisations_2BUjwU8Eh_cFt0B1K0p_sp8Xx29An7u_NDGwqdC8lEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations.vue?macro=true";
import { default as poolQuestionsQFOkVZ8gFKH8VrUm84idkTKX4ADFVBNcYmdLpdWGNR4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/poolQuestions.vue?macro=true";
import { default as indexGr7KYbnrqxJQdiVAWAkvC_25JVG3IpdDYnU0jB8zipcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/mailTemplates/index.vue?macro=true";
import { default as mailTemplateBaseDataDJtGW2UyNiH8v2Fd_45rRDErK0xMfdKHLLpZuO_wsI5foMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as system01pTkGPVSjTsQowhNOS7V_k6JwzWXK4OhENAyBuzetkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system.vue?macro=true";
import { default as userBaseDatakTAvkozPGhGztLdq4O6wF8O0HTX1iJHXASmsDOzKvdkMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesXOL4FkQ7CjriKpjgUvJ6mPISqhTDVtloHSxVbjQt01YMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id]/userActivities.vue?macro=true";
import { default as _91id_93ZnbV61kuPl9WzIFXQYvckA_45sPCO2hfboWs_45CVhNq6ssMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id].vue?macro=true";
import { default as organisationUsersCwujgaLZ9Bek_kz1xZMHvz8l2mTGuFLhVpy1nkxz9xUMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationUsers.vue?macro=true";
import { default as organisationPackagex30_utReyqI8JS4yysSkxQi9Ul4z_nzmLUIzVvbiFt4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationPackage.vue?macro=true";
import { default as organisationBaseDatacrTOlu3YSD8GfJB5dkzksGlr24GtAGmu7mLJmzpqDPAMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationBaseData.vue?macro=true";
import { default as organisationMailSettingsTPE9Wo_sQ_J8Y_zYunecZnOcw1ODAyJzslb_45dsOtHAMMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationMailSettings.vue?macro=true";
import { default as organisationrLMsOa1FxYy8Y_rwnfADomN_45KsXwxvNmouRMxJk3WC4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation.vue?macro=true";
import { default as mailTemplateBaseDatanoApP3uV6_45udYda_45A3IO6a9e_SljxOAkoUii_Suxg8QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as internalgS5ZqBnYqHLxT_CC4IRvbueU6Nd25jRt3ycmUjHuG_458Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal.vue?macro=true";
import { default as _91id_93tQRoTS84U3X4WRNifv1XuBZBsn2JCN0ZJPY8NtFYK1cMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/crisisManagers/[id].vue?macro=true";
import { default as _91id_93NYeSJee_cJLdOVe6Pm91eN6Gm7Kattr9_vCA26ZVpo0Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as indexwPbBBHb3SyqkAjiYDEeFnDTY1z9FrFZlcUmnjAKF16sMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/crisisManagers/index.vue?macro=true";
import { default as indexCvrAvNuGf2EeffWuY3yDlCZp04oPDVkQiSFZPI_45pWqoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as settingsFPFiA4PK7K7DE2iPa_45_45D_3Khyn_45rSDCAEcGvdbXbxd8Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings.vue?macro=true";
import { default as setBaseDataXbxTIFzB_Y_6WVJzuPndbpbI_45B_52YsRkF5tk8J8yiEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/[id]/setBaseData.vue?macro=true";
import { default as _91id_93OgiIyHVmQCwB1KFACwTucs4R0PopcBzu4GJyY7RynpoMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/[id].vue?macro=true";
import { default as index6rWS36v61o3PbrmI7qq_45Y89Mp1bE7vTElcZWMft1r7QMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/index.vue?macro=true";
import { default as setsQMQHZgXTb3hA3ldTA9GgEflQ1Y0RuwZlWRfuqan2hGQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets.vue?macro=true";
import { default as questionsL9HPVOmz5S3Z89iKi1XRWE3G8uCQxMdt_Z83xtMkYI4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions.vue?macro=true";
import { default as indexkPg5nzrUcH9vYRsrdZhrQTQYk_H4XJPwOvAfNsxrVxcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/index.vue?macro=true";
import { default as inputshnfhlhCLhm0NbWDCIflghLtOVD2mR8neR_v1dQ9KJOQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/inputs.vue?macro=true";
import { default as mosaich9qoyJclk8NQZIM3OetBOVFslXScd1rPjvNGXv9lS0IMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/mosaic.vue?macro=true";
import { default as dungeonkjSDc_45DfMgHxPXsljb_45M7xS8tZcmegbnIL2bwG6ec1MMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/dungeon.vue?macro=true";
import { default as componentsdsMfYCB941zunLszfuN1F6_45oUN_vNgJd4oH1MTZnQGEMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/components.vue?macro=true";
import { default as indexTdXwx_454boZR4BRuM1M6nTL1tXjMrxbqSnaE2CCKjQ0IMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index.vue?macro=true";
import { default as registerRi1WPHSqysC5rx6D9eWyNuSD5aTkSeiMU07wXLIsP_EMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/register.vue?macro=true";
import { default as _91leader_93pSzDtaQ_ZU2V3wAPJ0Z8RSkC7fv5Abxiz3_zR_451KZVcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/leader/[leader].vue?macro=true";
import { default as _91emergency_93jEYg0XANkblzURZbZvFsXZR9vHKpuvJWbt1EJsoyNesMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/emergency/[emergency].vue?macro=true";
import { default as _91temporary_93SGzkR7_456M87lrfQAgEdga429eOWBjtFpIYHyXDwkGF4Meta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/temporary/[temporary].vue?macro=true";
import { default as _91event_939uz_CVzSwLFoeNm8ffq8FKvV2uHha0kuJQT5bWeglxcMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event].vue?macro=true";
import { default as eventxvSSYFhtoKygOS3YozAVkO0E_45Nn69h_45NQnpFc4uik1kMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event.vue?macro=true";
import { default as index3IU3P3Ey56EeWgy6xJkrZTRwiBSUksfjBFYXiBd_45QJsMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/amos/[organisation]/index.vue?macro=true";
import { default as indexv1mL_45QqYI6CSr23Slqp9XYoMkz4_45zxfIeHP5SSF_45kHQMeta } from "/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/social/[organisation]/index.vue?macro=true";
export default [
  {
    name: "form",
    path: "/form",
    meta: formqG0RsFvSSWXQEUIc_454KwIMeW9KyXtuIE1HyKFQZl8kkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form.vue"),
    children: [
  {
    name: "form-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/[event].vue"),
    children: [
  {
    name: "form-event-participant-participant",
    path: "participant/:participant()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/[event]/participant/[participant].vue")
  }
]
  },
  {
    name: "form-signatures-signature",
    path: "signatures/:signature()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/form/signatures/[signature].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/index.vue")
  },
  {
    name: mailsMED_45SeZrpqJPIQK6zxNilenT8533u_45mq3_djTyjO2PIMeta?.name,
    path: "/mails",
    meta: mailsMED_45SeZrpqJPIQK6zxNilenT8533u_45mq3_djTyjO2PIMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails.vue"),
    children: [
  {
    name: "mails-id",
    path: ":id()",
    meta: { ...(_91id_93BhXzJL0ZpyYCowKB1ZIc2pZpp9ITlKs4gLsZumeaZPAMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id].vue"),
    children: [
  {
    name: "mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id]/mailBaseData.vue")
  },
  {
    name: "mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/[id]/mailActivities.vue")
  }
]
  },
  {
    name: "mails",
    path: "",
    meta: { ...(index0FEjRD7BUY4tDcM1_n5zrFY5cuVBwgGFeqvENZy809UMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/mails/index.vue")
  }
]
  },
  {
    name: eventskyP66TkMocj_2d1b72io1tgcLh75x_9TMpakHhu6xdkMeta?.name,
    path: "/events",
    meta: eventskyP66TkMocj_2d1b72io1tgcLh75x_9TMpakHhu6xdkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events.vue"),
    children: [
  {
    name: "events-id",
    path: ":id()",
    meta: _91id_93g9dnXxkAggTTYt5AYIKRohD5zR2HbECUG3fc8Su_45_nQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id].vue"),
    children: [
  {
    name: "events-id-eventMails",
    path: "eventMails",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventMails.vue")
  },
  {
    name: "events-id-eventLeaders",
    path: "eventLeaders",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventLeaders.vue")
  },
  {
    name: "events-id-eventBaseData",
    path: "eventBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventBaseData.vue")
  },
  {
    name: "events-id-eventQuestions",
    path: "eventQuestions",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventQuestions.vue")
  },
  {
    name: "events-id-eventActivities",
    path: "eventActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventActivities.vue")
  },
  {
    name: "events-id-eventParticipants",
    path: "eventParticipants",
    meta: eventParticipantskaSyFNJD8XigIggykfwT5FBQtZ8YTuJHCiFOsIEcJ8oMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventParticipants.vue")
  },
  {
    name: "events-id-eventCrisisManagers",
    path: "eventCrisisManagers",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventCrisisManagers.vue")
  },
  {
    name: "events-id-eventParticipantGroups",
    path: "eventParticipantGroups",
    meta: eventParticipantGroupszbxvEVfTxw7zz27Xa4davVwPvIiCRuFpv31N51nBNCUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventParticipantGroups.vue")
  },
  {
    name: "events-id-eventTemporaryAccesses",
    path: "eventTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[id]/eventTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events",
    path: "",
    meta: { ...(indexXg7mraTWj9m1_45Y9ZaeM2y_YNEdhLnVuqizQjzLwzsskMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/index.vue")
  },
  {
    name: "events-event-participants-id",
    path: ":event()/participants/:id()",
    meta: _91id_93dxAdcRTLYH6AGXijLM_pm6roRGqwlmmqST0n5HSeIGUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id].vue"),
    children: [
  {
    name: "events-event-participants-id-participantMails",
    path: "participantMails",
    meta: participantMailsnNsykB2foWanwb9gyeCtBDGUqcmcxMd6il_3ZTK28EgMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantMails.vue")
  },
  {
    name: "events-event-participants-id-participantAnswers",
    path: "participantAnswers",
    meta: participantAnswers14n28sM8siQtwNXchXppQ6YroHU0_45ORl78iPpPz9XV0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantAnswers.vue")
  },
  {
    name: "events-event-participants-id-participantBaseData",
    path: "participantBaseData",
    meta: participantBaseData0IX3CC0JlXU7N1XHw2A5LiviPeWvGyCenXtwHbzRUZMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantBaseData.vue")
  },
  {
    name: "events-event-participants-id-participantGuardians",
    path: "participantGuardians",
    meta: participantGuardiansrigEBcwoQ4Vo9SW5GetqBIfS6qMDYba9a3DFVui2dXIMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantGuardians.vue")
  },
  {
    name: "events-event-participants-id-participantActivities",
    path: "participantActivities",
    meta: participantActivities55dTzgVMjynV36PJrpVeVEJnMf4EuoSGJxwnvQZaZHUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantActivities.vue")
  },
  {
    name: "events-event-participants-id-participantSubmissions",
    path: "participantSubmissions",
    meta: participantSubmissionsImFarlVDPJ3zy76Qj3fKYFbbnnmsbnaJlmYExTxvgUUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantSubmissions.vue")
  },
  {
    name: "events-event-participants-id-participantEmergencyContacts",
    path: "participantEmergencyContacts",
    meta: participantEmergencyContactsnX7Wok1pn_45hDSeOmjM6KtIEOJh_C0Eh9bESUIlniy2AMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantEmergencyContacts.vue")
  },
  {
    name: "events-event-participants-id-participantTemporaryAccesses",
    path: "participantTemporaryAccesses",
    meta: participantTemporaryAccessesxRc6Cx_ufY8kgpLjKRoKQdSf0ZVURlD3U7FpjvEjH68Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participants/[id]/participantTemporaryAccesses.vue")
  }
]
  },
  {
    name: "events-event-participantGroups-id",
    path: ":event()/participantGroups/:id()",
    meta: _91id_93mPacRK0fkwgFCmv6HVI1hJVICZv4FvjsRWhVZVAG8W8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id].vue"),
    children: [
  {
    name: "events-event-participantGroups-id-groupBaseData",
    path: "groupBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupBaseData.vue")
  },
  {
    name: "events-event-participantGroups-id-groupActivities",
    path: "groupActivities",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupActivities.vue")
  },
  {
    name: "events-event-participantGroups-id-groupParticipants",
    path: "groupParticipants",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupParticipants.vue")
  },
  {
    name: "events-event-participantGroups-id-groupTemporaryAccesses",
    path: "groupTemporaryAccesses",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/events/[event]/participantGroups/[id]/groupTemporaryAccesses.vue")
  }
]
  }
]
  },
  {
    name: "system",
    path: "/system",
    meta: system01pTkGPVSjTsQowhNOS7V_k6JwzWXK4OhENAyBuzetkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system.vue"),
    children: [
  {
    name: "system-roles",
    path: "roles",
    meta: rolese9qVgEPhepilx9ACHHNzzOwi7j185v4JnTzJWbZdQnIMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/roles.vue")
  },
  {
    name: usersUBAr39kuqJfJIGx8Vg63QaYFcCk__45ijuJdUV0G_FT0YMeta?.name,
    path: "users",
    meta: usersUBAr39kuqJfJIGx8Vg63QaYFcCk__45ijuJdUV0G_FT0YMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users.vue"),
    children: [
  {
    name: "system-users-id",
    path: ":id()",
    meta: { ...(_91id_93KUuun7gxHf3_45WKxPm_Z2sshCWAHw18Vit3mJQNd_z_45sMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id].vue"),
    children: [
  {
    name: "system-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDataeuXG8zlPBC30UE2TBopR2qDfUatS4SwgAxApHmfD5dwMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id]/userBaseData.vue")
  },
  {
    name: "system-users-id-userActivities",
    path: "userActivities",
    meta: userActivities0CVwxdPMwuDfSN_Byf5D6e1xEN_aYGaaQapV_QfuDlUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "system-users",
    path: "",
    meta: { ...(indexquPaGhj37fax3TEDG0_oIplSr0bCDgEsfxM_W1c_l4YMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/users/index.vue")
  }
]
  },
  {
    name: "system-baseData",
    path: "baseData",
    meta: baseDatatz6VQEQwLuXjSy9mT5kMdhtUYZ_45ItXzKU6LZv_45e6I_8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/baseData.vue")
  },
  {
    name: "system-billings",
    path: "billings",
    meta: billingsFFr0cD8JBXwmdFDkrjzMH6WiYRMtpk6bzswkwGeDLksMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/billings.vue")
  },
  {
    name: "system-billingRuns",
    path: "billingRuns",
    meta: billingRunsbaL5crpPxGtKcdejUfJ_lYbn97F9yfIgwBhpDK_45A5foMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/billingRuns.vue")
  },
  {
    name: organisations_2BUjwU8Eh_cFt0B1K0p_sp8Xx29An7u_NDGwqdC8lEMeta?.name,
    path: "organisations",
    meta: organisations_2BUjwU8Eh_cFt0B1K0p_sp8Xx29An7u_NDGwqdC8lEMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations.vue"),
    children: [
  {
    name: "system-organisations-id",
    path: ":id()",
    meta: { ...(_91id_93P6eMFxI5D73BqCKZSzaYDNKKClgsdm73vzSP2aETxbIMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id].vue"),
    children: [
  {
    name: "system-organisations-id-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersxZZIfsV0BCOKuDsz56Hum2xnAjaKPu40Z8_Hgj3SuoMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationUsers.vue")
  },
  {
    name: "system-organisations-id-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackagexaNjgE2TVNcS1U187_5WQcqIsmU3ah3FUcAD3aoPyQMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationPackage.vue")
  },
  {
    name: "system-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDataydTtmgo8ZPNavOYLWnI_45USj8l4jeIliA7sQOEofdiX0Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "system-organisations-id-organisationActivities",
    path: "organisationActivities",
    meta: organisationActivitiesW6Rp0kJT_45pOwvzHfvJCeTp_45luXUcMTaU_ImuUsWF03EMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "system-organisations-id-organisationSystemData",
    path: "organisationSystemData",
    meta: organisationSystemDataNYbSES1by_45QJfo1z8id8A_45GyY7hz3aoXmPnnkDfdVlMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationSystemData.vue")
  },
  {
    name: "system-organisations-id-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingskXMpvZdzU1is2NMC4k45K2AOlCbTPlX8d2amBE_452Z9QMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/[id]/organisationMailSettings.vue")
  }
]
  },
  {
    name: "system-organisations",
    path: "",
    meta: { ...(indexuyWTt7ctz_NJixtYRy3ZyD9bAkqHOrK1zSU4ybFE17EMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/organisations/index.vue")
  }
]
  },
  {
    name: "system-poolQuestions",
    path: "poolQuestions",
    meta: poolQuestionsQFOkVZ8gFKH8VrUm84idkTKX4ADFVBNcYmdLpdWGNR4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/poolQuestions.vue")
  },
  {
    name: "system-mailTemplates",
    path: "mailTemplates",
    meta: { ...(indexGr7KYbnrqxJQdiVAWAkvC_25JVG3IpdDYnU0jB8zipcMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/mailTemplates/index.vue")
  },
  {
    name: "system-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDataDJtGW2UyNiH8v2Fd_45rRDErK0xMfdKHLLpZuO_wsI5foMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/system/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsFPFiA4PK7K7DE2iPa_45_45D_3Khyn_45rSDCAEcGvdbXbxd8Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings.vue"),
    children: [
  {
    name: "settings-internal",
    path: "internal",
    meta: internalgS5ZqBnYqHLxT_CC4IRvbueU6Nd25jRt3ycmUjHuG_458Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal.vue"),
    children: [
  {
    name: "settings-internal-users-id",
    path: "users/:id()",
    meta: { ...(_91id_93ZnbV61kuPl9WzIFXQYvckA_45sPCO2hfboWs_45CVhNq6ssMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id].vue"),
    children: [
  {
    name: "settings-internal-users-id-userBaseData",
    path: "userBaseData",
    meta: userBaseDatakTAvkozPGhGztLdq4O6wF8O0HTX1iJHXASmsDOzKvdkMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-internal-users-id-userActivities",
    path: "userActivities",
    meta: userActivitiesXOL4FkQ7CjriKpjgUvJ6mPISqhTDVtloHSxVbjQt01YMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/users/[id]/userActivities.vue")
  }
]
  },
  {
    name: "settings-internal-organisation",
    path: "organisation",
    meta: { ...(organisationrLMsOa1FxYy8Y_rwnfADomN_45KsXwxvNmouRMxJk3WC4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation.vue"),
    children: [
  {
    name: "settings-internal-organisation-organisationUsers",
    path: "organisationUsers",
    meta: organisationUsersCwujgaLZ9Bek_kz1xZMHvz8l2mTGuFLhVpy1nkxz9xUMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationUsers.vue")
  },
  {
    name: "settings-internal-organisation-organisationPackage",
    path: "organisationPackage",
    meta: organisationPackagex30_utReyqI8JS4yysSkxQi9Ul4z_nzmLUIzVvbiFt4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationPackage.vue")
  },
  {
    name: "settings-internal-organisation-organisationBaseData",
    path: "organisationBaseData",
    meta: organisationBaseDatacrTOlu3YSD8GfJB5dkzksGlr24GtAGmu7mLJmzpqDPAMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationBaseData.vue")
  },
  {
    name: "settings-internal-organisation-organisationMailSettings",
    path: "organisationMailSettings",
    meta: organisationMailSettingsTPE9Wo_sQ_J8Y_zYunecZnOcw1ODAyJzslb_45dsOtHAMMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/organisation/organisationMailSettings.vue")
  }
]
  },
  {
    name: "settings-internal-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplates/:id()/mailTemplateBaseData",
    meta: { ...(mailTemplateBaseDatanoApP3uV6_45udYda_45A3IO6a9e_SljxOAkoUii_Suxg8QMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/internal/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "settings-crisisManagers-id",
    path: "crisisManagers/:id()",
    meta: { ...(_91id_93tQRoTS84U3X4WRNifv1XuBZBsn2JCN0ZJPY8NtFYK1cMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/crisisManagers/[id].vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "loginProviders/:id()",
    meta: { ...(_91id_93NYeSJee_cJLdOVe6Pm91eN6Gm7Kattr9_vCA26ZVpo0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-crisisManagers",
    path: "crisisManagers",
    meta: { ...(indexwPbBBHb3SyqkAjiYDEeFnDTY1z9FrFZlcUmnjAKF16sMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/crisisManagers/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "loginProviders",
    meta: { ...(indexCvrAvNuGf2EeffWuY3yDlCZp04oPDVkQiSFZPI_45pWqoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsL9HPVOmz5S3Z89iKi1XRWE3G8uCQxMdt_Z83xtMkYI4Meta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions.vue"),
    children: [
  {
    name: setsQMQHZgXTb3hA3ldTA9GgEflQ1Y0RuwZlWRfuqan2hGQMeta?.name,
    path: "sets",
    meta: setsQMQHZgXTb3hA3ldTA9GgEflQ1Y0RuwZlWRfuqan2hGQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets.vue"),
    children: [
  {
    name: "questions-sets-id",
    path: ":id()",
    meta: { ...(_91id_93OgiIyHVmQCwB1KFACwTucs4R0PopcBzu4GJyY7RynpoMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/[id].vue"),
    children: [
  {
    name: "questions-sets-id-setBaseData",
    path: "setBaseData",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/[id]/setBaseData.vue")
  }
]
  },
  {
    name: "questions-sets",
    path: "",
    meta: { ...(index6rWS36v61o3PbrmI7qq_45Y89Mp1bE7vTElcZWMft1r7QMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/questions/sets/index.vue")
  }
]
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexkPg5nzrUcH9vYRsrdZhrQTQYk_H4XJPwOvAfNsxrVxcMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-mosaic",
    path: "mosaic",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/mosaic.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-components",
    path: "components",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/secret/index/components.vue")
  }
]
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: registerRi1WPHSqysC5rx6D9eWyNuSD5aTkSeiMU07wXLIsP_EMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/register.vue")
  },
  {
    name: "external-event",
    path: "/external/event",
    meta: eventxvSSYFhtoKygOS3YozAVkO0E_45Nn69h_45NQnpFc4uik1kMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event.vue"),
    children: [
  {
    name: "external-event-event",
    path: ":event()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event].vue"),
    children: [
  {
    name: "external-event-event-leader-leader",
    path: "leader/:leader()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/leader/[leader].vue")
  },
  {
    name: "external-event-event-emergency-emergency",
    path: "emergency/:emergency()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/emergency/[emergency].vue")
  },
  {
    name: "external-event-event-temporary-temporary",
    path: "temporary/:temporary()",
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/external/event/[event]/temporary/[temporary].vue")
  }
]
  }
]
  },
  {
    name: "auth-amos-organisation",
    path: "/auth/amos/:organisation()",
    meta: index3IU3P3Ey56EeWgy6xJkrZTRwiBSUksfjBFYXiBd_45QJsMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/amos/[organisation]/index.vue")
  },
  {
    name: "auth-social-organisation",
    path: "/auth/social/:organisation()",
    meta: indexv1mL_45QqYI6CSr23Slqp9XYoMkz4_45zxfIeHP5SSF_45kHQMeta || {},
    component: () => import("/home/forge/app.freizeitpass-digital.de/releases/82211283/client/pages/auth/social/[organisation]/index.vue")
  }
]